var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArkChatLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 366.2 74.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #db0011;\n      }\n\n      .cls-3 {\n        fill: #231f20;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.9,46.7h-.1c0,.1-22.3,22.5-22.3,22.5H5.4l22.5-22.5L6.5,25.4h32.1l21.2,21.2h.1c0,.1,0,.1,0,.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.4,25v4.7h-.2c-3.1-3.7-7.2-5.5-12.1-5.5s-5.5.6-7.9,1.7c-2.5,1.1-4.6,2.7-6.4,4.7-1.8,2-3.2,4.4-4.2,7.3-1,2.9-1.5,5.9-1.5,9.2s.5,6.5,1.5,9.3c1,2.8,2.4,5.2,4.3,7.2,1.8,2,4,3.5,6.6,4.6,2.6,1.1,5.4,1.7,8.3,1.7,5.3,0,9.4-1.9,12.2-5.6h.2v4.7h13.4V25h-14.1ZM97.3,54.6c-1.8,1.9-4,2.9-6.6,2.9s-5-1-6.8-2.9c-1.8-1.9-2.6-4.4-2.6-7.5s.9-5.6,2.7-7.6c1.8-1.9,4-2.9,6.8-2.9s3.3.5,4.7,1.3c1.4.9,2.5,2.1,3.3,3.7.8,1.6,1.2,3.4,1.2,5.4,0,3.1-.9,5.6-2.7,7.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.8,24.2c-1.6,0-3.2.3-4.7.8-1.5.5-3,1.3-4.3,2.3-1.4,1-2.6,2.2-3.7,3.7h-.2v-5.9h-14.1v44h14.1v-19.8c0-1.9.4-3.6,1.1-5.1.8-1.5,1.9-2.7,3.4-3.5,1.5-.9,3.4-1.3,5.5-1.3s2.5,0,3.3,0v-15.2c0,0-.2,0-.5,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.3,42.2l15.1-17.2h-16.3l-12.7,14.6h-.2V3l-14.1,14.1v52h14.1v-10.9l4.7-5.3h.2l9.1,16.1h15.6l-15.5-26.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.1,53.3c-2.4,2.7-5.4,4-9,4s-2.8-.2-4.1-.8c-1.2-.5-2.3-1.2-3.2-2.1-.9-.9-1.6-2-2-3.3-.5-1.3-.7-2.7-.7-4.2,0-3,.9-5.5,2.7-7.4,1.8-1.9,4.2-2.8,7.2-2.8s6.8,1.4,9.1,4.3l9.4-8c-2.2-2.8-4.9-5-8.3-6.5-3.4-1.5-7-2.3-10.7-2.3s-8.6,1-12.2,2.9c-3.6,1.9-6.4,4.6-8.4,8.1-2,3.5-3,7.5-3,11.9s1,8.4,3,11.9c2,3.5,4.7,6.2,8.2,8.1,3.5,1.9,7.3,2.9,11.7,2.9s8.3-.8,11.8-2.3c3.4-1.5,6.2-3.5,8.2-5.9l-9.6-8.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.3,33.8c-.8-2.4-1.9-4.3-3.4-5.7-1.5-1.4-3.1-2.4-5-3-1.8-.6-4-1-6.4-1s-5.2.5-7.5,1.5c-2.3,1-4.4,2.5-6.1,4.4h-.2V2.8h-.3l-13.8,13.8v52.5h14.1v-22.2h0c0-3.3.7-5.9,2.2-7.6,1.5-1.7,3.5-2.5,6-2.5s4.4.7,5.6,2c1.1,1.4,1.7,3.7,1.7,7.2v23.1h14.1v-26.5c0-3.4-.4-6.3-1.2-8.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.7,25v4.7h-.2c-3.1-3.7-7.2-5.5-12.1-5.5s-5.5.6-7.9,1.7c-2.5,1.1-4.6,2.7-6.4,4.7-1.8,2-3.2,4.4-4.2,7.3-1,2.9-1.5,5.9-1.5,9.2s.5,6.5,1.5,9.3c1,2.8,2.4,5.2,4.3,7.2,1.8,2,4,3.5,6.6,4.6,2.6,1.1,5.4,1.7,8.4,1.7,5.3,0,9.4-1.9,12.2-5.6h.2v4.7h13.4V25h-14.1ZM312.6,54.6c-1.8,1.9-4,2.9-6.6,2.9s-5-1-6.8-2.9c-1.8-1.9-2.6-4.4-2.6-7.5s.9-5.6,2.7-7.6c1.8-1.9,4.1-2.9,6.8-2.9s3.3.5,4.7,1.3c1.4.9,2.5,2.1,3.3,3.7.8,1.6,1.2,3.4,1.2,5.4,0,3.1-.9,5.6-2.7,7.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.3,56.5c-1.4.7-2.9,1.1-4.3,1.1s-2.1-.4-2.6-1.3c-.5-.9-.7-2.1-.7-3.7v-16.1h10.7v-11.5h-10.7V3l-14.1,14.1v8h-5v11.5h5v18.7c0,4.8,1.2,8.5,3.5,10.9,2.3,2.5,5.5,3.7,9.4,3.7s5.1-.3,6.9-.8c1.8-.5,3.6-1.3,5.4-2.3l-3.5-10.4Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 162.2,
    y1: 3,
    x2: 148.1,
    y2: 17
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 248.6,
    y1: 2.8,
    x2: 234.8,
    y2: 16.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 350.6,
    y1: 3,
    x2: 336.5,
    y2: 17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkChatLogo);
export default __webpack_public_path__ + "static/media/arkChatLogo.6fc0c3b62379b38733d6058aaff19920.svg";
export { ForwardRef as ReactComponent };